<template>
   <swiper
      :modules="modules"
      :initial-slide="indexLive"
      navigation
      mousewheel
      class="player__sidebar slider-film slid_playlist"
      :slides-per-group="1"
      :slides-per-view="1"
      :slides-offset-before="-4"
      :slides-offset-after="0"
      :space-between="0"
      :breakpoints="breakpoint"
      @swiper="getLiveTrackRef"
   >
      <swiper-slide
         class="player__sidebar_item"
         v-for="(list, index) in playlist"
         :class="{ active: index === indexLive }"
      >
         <div class="player__sidebar_item_inner">
            <p class="player__sidebar_time">
               <span>{{ CorTime(list.time_to_start) }}</span>
               <span
                  class="player__sidebar_name_age"
                  v-if="list.video.censored != 99"
               >
                  {{ list.video.censored }}+
               </span>
            </p>
            <div class="player__sidebar_progres">
               <span
                  v-if="index === indexLive && timeToEnd !== 0"
                  :style="{ width: timeLive + '%' }"
               ></span>
            </div>
            <div class="player__sidebar_name">
               <p>{{ list.video.name }}</p>
            </div>
         </div>
      </swiper-slide>
   </swiper>
</template>

<style lang="scss" scoped>
.player__sidebar_time {
   position: relative;
}

.player__sidebar_name {
   display: flex;
   position: relative;

   &_age {
      position: absolute;
      top: 6px;
      right: 0;
      color: #82909f;
      font-family: "Inter", sans-serif;
      font-size: 13px;
      font-weight: 600;
      line-height: 120%;
      border-radius: 28px;
      background: #edf0f3;
      padding: 2px 7px;
   }
}
</style>

<script lang="js">
import moment from "moment";
import { Swiper, SwiperSlide } from "swiper/vue";
import { useI18n } from "vue-i18n";
import { Navigation, Mousewheel } from "swiper";
import { defineComponent, toRefs, computed, ref, watch } from "vue";
import { decodeTime } from "@/utils/datetime";

const getTime = (locale) => (timeValue) => {
   return decodeTime(timeValue, locale.value);
}

const breakpoint = {
   640: {
      direction: "horizontal",
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      centeredSlides: false,
   },
   1194: {
      direction: "horizontal",
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      centeredSlides: false,
   },
   1280: {
      direction: "horizontal",
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
      centeredSlides: false,
   },
   1366: {
      direction: "horizontal",
      spaceBetween: 0,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
   },
   1920: {
      direction: "horizontal",
      spaceBetween: 0,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
   },
   2560: {
      direction: "horizontal",
      spaceBetween: 0,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 16,
   },
};

export default defineComponent({
   name: "LiveTrack",
   components: { Swiper, SwiperSlide },
   props: {
      playList: {
         type: Array,
         required: true,
      },
      currentTime: {
         type: String,
         required: true,
      },
   },
   setup(props) {
      const { locale } = useI18n();
      const { currentTime: curTime, playList } = toRefs(props);
      const liveTrackRef = ref(null);

      const time = computed(() => moment.duration(curTime.value).asSeconds());

      const playlist = computed(() => {
         return playList.value.filter((item) => item.time_to_start !== "" && item.video.draft !== 2);

         let temp = playList.value.filter((item) => item.time_to_start !== "" && item.video.draft !== 2);
         const today = new Date(); // Текущая дата
         const tomorrow = new Date(today);
         tomorrow.setDate(today.getDate() + 1); // Завтрашняя дата

               playList.value
                  .map((item) => item.time_to_start)
                  .map((time) => {
                     const [hours, minutes, seconds] = time
                        .split(":")
                        .map(Number);
                     const date = new Date(today); // Начинаем с сегодняшней даты

                     if (hours < 3) {
                        // Если время после полуночи (00:00 - 01:59), это завтрашний день
                        date.setDate(tomorrow.getDate());
                     }

                     date.setHours(hours, minutes, seconds, 0); // Устанавливаем время
                     return date;
                  })
                  .forEach((element, index) => {
                     temp[index].convertedTime = element.getTime();
                  });
         return temp;
         // return playList.value.filter((item) => item.time_to_start !== "" && item.video.draft !== 2);
      });

      const index = computed(() => {
         // const now = new Date().getTime();

         // const closestInPlaylist = playlist.value.findIndex(
         //    (item) => item.convertedTime > now
         // );
         // if (closestInPlaylist == -1) {
         //    return playlist.value.length - 1;
         // } else {
         //    return closestInPlaylist - 1;
         // }
         if (time.value < 3600 * 7) {
            let newArr = playlist.value.filter(item => moment.duration(item.time_to_start).asSeconds() <= 3600 * 7)

            let index = newArr.findIndex((item) => time.value <= moment.duration(item.time_to_start).asSeconds()) - 1
            if (index == -2) {
               return -2
            } else {
               return playlist.value.findIndex(item => item.time_to_start == newArr[index]?.time_to_start)
            }

         } else {
            return playlist.value.findIndex((item) => time.value <= moment.duration(item.time_to_start).asSeconds()) - 1;
         }


      });

      const indexLive = computed(() => {
         if (index.value === -2) {
            return playlist.value.length - 1;
         }

         return Math.max(0, index.value);
      });

      const timeToStart = computed(() => {
         return moment.duration(playlist.value[indexLive.value].time_to_start).asSeconds();
      });

      const timeToEnd = computed(() => {
         return Number(playlist.value[indexLive.value].video.duration) + 30;
      });

      const timeLive = computed(() => {
         if (indexLive.value === -1) {
            return 0;
         }

         return ((time.value - timeToStart.value) / timeToEnd.value) * 100;
      });

      const getLiveTrackRef = (swiper) => {
         liveTrackRef.value = swiper;
      };

      const CorTime = getTime(locale);

      watch(indexLive, (newIndex, oldIndex) => {
         if (newIndex == oldIndex) return;

         if (!liveTrackRef.value) return;

         liveTrackRef.value.slideTo(newIndex);
      });

      return {
         modules: [Navigation, Mousewheel],
         CorTime,
         breakpoint,
         playlist,
         indexLive,
         timeLive,
         getLiveTrackRef,
         timeToEnd,
      };
   }
});
</script>
